import { render, staticRenderFns } from "./change-preview-type.vue?vue&type=template&id=3f0bfbe4&scoped=true"
import script from "./change-preview-type.vue?vue&type=script&lang=ts"
export * from "./change-preview-type.vue?vue&type=script&lang=ts"
import style0 from "./change-preview-type.vue?vue&type=style&index=0&id=3f0bfbe4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0bfbe4",
  null
  
)

export default component.exports